import { render, staticRenderFns } from "./dialog_confirmacao_desativar.vue?vue&type=template&id=8240349e"
import script from "./dialog_confirmacao_desativar.vue?vue&type=script&lang=js"
export * from "./dialog_confirmacao_desativar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports